import { X } from "lucide-react";
import { Link } from "react-router-dom";

export default function InfoPop({ item, onClose }) {
  if (!item) return null;
  return (
    <div className="fixed inset-0 z-[80] bg-black/70 flex items-center justify-center p-4" onClick={onClose} data-testid="info-pop">
      <div className="relative bg-ivory text-ink max-w-md w-full max-h-[90vh] overflow-y-auto gold-frame" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} aria-label="Close" data-testid="info-pop-close" className="absolute top-3 right-3 z-10 w-8 h-8 rounded-full border border-gold bg-ivory text-gold flex items-center justify-center"><X size={16} /></button>
        {item.img && <img src={item.img} alt="" className="w-full aspect-[16/9] object-cover" />}
        <div className="p-7">
          {item.tag && <p className="eyebrow !text-[0.55rem] mb-2">{item.tag}</p>}
          <h3 className="font-headline text-2xl leading-snug">{item.name}</h3>
          {item.place && <p className="text-xs text-ink/50 mt-1">{item.place}</p>}
          <p className="mt-4 text-sm text-ink/75 leading-relaxed">{item.blurb}</p>
          {item.sections?.map(([h, t]) => (
            <div key={h} className="mt-4 border-t border-gold/30 pt-3"><p className="eyebrow !text-[0.52rem] mb-1">{h}</p><p className="text-sm text-ink/75 leading-relaxed">{t}</p></div>
          ))}
          <Link to={item.to || "/contact?topic=Conciergerie"} onClick={onClose} className="btn-lux mt-6 inline-block bg-forest text-ivory hover:bg-gold hover:text-ink">{item.cta || "Plan your experience"}</Link>
        </div>
      </div>
    </div>
  );
}
